exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-panel .ui-g .ui-g-12 {\n    padding: 20px 30px;\n}\n\n.login-panel {\n    width: 380px;\n    height: 480px;\n}\n\n.button-set-api {\n    background-color: #3e464c !important;\n    margin: 0 auto !important;\n}\n\n.logo {\n    width: 85%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main